export default __webpack_public_path__ + "7a47ab4031b76f8a08db2b0f547824c9.png";